import { useState, useEffect } from 'react'
import CommonService from '../services/CommonService';
import UserService from '../services/UserService';

import {
    Box, Button, FormControl, FormLabel, Grid, Input, Select, Text, Link, Avatar,
    HStack, Heading, useToast
} from "@chakra-ui/react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from 'react-router-dom';
import config from '../constants/config';

const Profile = () => {

    const user = JSON.parse(localStorage.getItem("user"));
    const navigate = useNavigate()

    const backendUrl = config.apiBaseUrl;

    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [countryId, setCountryId] = useState(0);
    const [cityId, setCityId] = useState(0);

    const [userPic, setuserPicPic] = useState("");
    const [aadharPic, setAadharPic] = useState("");
    const [PANPic, setPANPic] = useState("");
    const [licensePic, setLicensePic] = useState("");
    const [userData, setUserData] = useState()
    const toast = useToast();
    const isSubmitted = userData?.Aadhar !== "" && userData?.kycApprove === 0;
    const isApproved = userData?.kycApprove === 5; // Approved
    const isRejected = userData?.kycApprove === 2; // rejected
    const isDisabled = isSubmitted || isApproved;

    const schema = yup.object().shape({
        DOB: yup.string().required("Date of Birth is required"),
        Gender: yup.string().required("Gender is required").notOneOf(["0"], "Gender is required"),
        profilePic: yup
            .mixed()
            .test("fileType", "Only JPEG/PNG images allowed", (value) => {
                return !value || ["image/jpeg", "image/png"].includes(value.type);
            }),
        // aadhar: yup.mixed().required("Aadhar is required"),
        // PAN: yup.mixed().required("PAN is required"),
        // license: yup.mixed().required("License is required"),
        CountryCd: yup.string().required("Country is required").notOneOf(["0"], "Country is required"),
        CityCd: yup.string().required("City is required").notOneOf(["0"], "City are required"),
        FName: yup.string().required("Firstname is required"),
        LName: yup.string().required("Lastname is required"),
        Email: yup.string().required("Email is required"),
    });

    const {
        handleSubmit,
        register,
        setValue,
        watch,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        getCountry();
    }, []);

    const getCountry = async () => {
        try {
            const data = await CommonService.getCountry();
            setCountryId(0);
            setCountries(data);
            userDetail();
        } catch (error) {

            toast({
                title: 'Error fetching users',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }

    const userDetail = async () => {
        let param = {
            uId: user.uId
        };

        try {
            const res = await UserService.getUserDetail(param);
            if (res.statusCode === 200) {
                setUserData(res.data)
                setValue("FName", res.data.FName)
                setValue("LName", res.data.LName)
                setValue("MobileNo", res.data.MobileNo)
                setValue("Email", res.data.Email)
                setValue("DOB", res.data.DOB?.substring(0, 10))
                setValue("Gender", res.data.Gender?.toString())
                setValue("CountryCd", res.data.CountryCd)
                setValue("CityCd", res.data.CityCd)
                setuserPicPic(res.data.ProfilePic)
                setAadharPic(res.data.Aadhar)
                setPANPic(res.data.PAN)
                setLicensePic(res.data.Licence)

                setCountryId(res.data.CountryCd);
                setCityId(res.data.CityCd);
                getCity(res.data.CountryCd); // Fetch cities for selected country


            }

        } catch (error) {
            toast({
                title: 'Error fetching users',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }

    const handleCountryChange = (e) => {
        const selected = e.target.value;
        setCountryId(selected);
        setValue('CountryCd', selected);
        getCity(selected);
    };

    const handleCityChange = (e) => {
        const selected = e.target.value;
        setCityId(selected);
        setValue('CityCd', selected);
    };

    const getCity = async (countryId) => {
        setCities([]);
        let param = {
            countryId: countryId
        };

        try {
            if (countryId) {
                const data = await CommonService.getCountryByCountryId(param);
                setCities(data);
            }
        } catch (error) {
            toast({
                title: 'Error fetching users',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }

    const handleProfile = async (data) => {

        const {
            profilePic,
            aadhar,
            PAN,
            license,
        } = watch();

        if (!userData.ProfilePic && !profilePic) {
            alert("Please upload profile picture");
            return;
        }
        if (!userData.Aadhar && !aadhar) {
            alert("Please upload aadhar picture");
            return;
        } if (!userData.PAN && !PAN) {
            alert("Please upload PAN picture");
            return;
        } if (!userData.Licence && !license) {
            alert("Please upload license picture");
            return;
        }
        const formDt = new FormData();
        formDt.append("uId", user.uId);
        formDt.append("FName", data.FName);
        formDt.append("LName", data.LName);
        formDt.append("Email", data.Email);
        formDt.append("DOB", data.DOB);
        formDt.append("Gender", data.Gender);
        formDt.append("CountryCd", data.CountryCd);
        formDt.append("CityCd", data.CityCd);
        // formDt.append("profilePic", data.profilePic);
        // formDt.append("aadhar", data.aadhar);
        // formDt.append("PAN", data.PAN);
        // formDt.append("license", data.license);

        if (profilePic) formDt.append("profilePic", profilePic);
        if (aadhar) formDt.append("aadhar", aadhar);
        if (PAN) formDt.append("PAN", PAN);
        if (license) formDt.append("license", license);

        const res = await UserService.updateProfile(formDt);
        if (res.statusCode === 200) {
            toast({
                title: res.message,
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
            // reset();
            // Reload the current page
            navigate(0);
        }
    };

    return (
        <Box maxW="1000px" mx="auto" px={4}>
            <Box maxW="900px" mx="auto" mt={2}>
                {/* Profile Info Header */}
                <Box bg="blue.500" color="white" py={3} px={6} borderTopRadius="lg">
                    <Heading size="sm" textAlign='center'>Profile Info</Heading>
                </Box>

                {/* Form Card Body */}
                <Box
                    bg="white"
                    p={3}
                    roundedBottom="xl"
                    boxShadow="md"
                    border="1px solid"
                    borderColor="gray.200"
                    position="relative"
                >
                    <Box textAlign="center" mb={4}>
                        <Avatar
                            size="xl"
                            name={`${watch("FName") || ""} ${watch("LName") || ""}`}
                            src={`${backendUrl}/profile/${userPic}`}
                            mx="auto"
                            boxShadow="lg"
                        />
                    </Box>

                    <form onSubmit={handleSubmit(handleProfile)}>
                        <Grid
                            templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                            gap={3}
                        >
                            {/* First Name */}
                            <FormControl isInvalid={errors.FName}>
                                <FormLabel fontSize="sm">First Name</FormLabel>
                                <Input type="text" name="FName" {...register("FName")} size="sm" />
                                {errors.FName && <Text color="red.500">{errors.FName.message}</Text>}
                            </FormControl>

                            {/* Last Name */}
                            <FormControl isInvalid={errors.LName}>
                                <FormLabel fontSize="sm">Last Name</FormLabel>
                                <Input type="text" name="LName" {...register("LName")} size="sm" />
                                {errors.LName && <Text color="red.500">{errors.LName.message}</Text>}
                            </FormControl>

                            {/* Mobile No */}
                            <FormControl>
                                <FormLabel fontSize="sm">Mobile No</FormLabel>
                                <Input type="text" name="MobileNo" {...register("MobileNo")} size="sm" isReadOnly />
                            </FormControl>

                            {/* Email */}
                            <FormControl isInvalid={errors.Email}>
                                <FormLabel fontSize="sm">Email</FormLabel>
                                <Input type="text" name="Email" {...register("Email")} size="sm" />
                                {errors.Email && <Text color="red.500">{errors.Email.message}</Text>}
                            </FormControl>

                            {/* DOB */}
                            <FormControl isInvalid={errors.DOB}>
                                <FormLabel fontSize="sm">DOB</FormLabel>
                                <Input type="date" name="DOB" {...register("DOB")} size="sm" />
                                {errors.DOB && <Text color="red.500">{errors.DOB.message}</Text>}
                            </FormControl>

                            {/* Gender */}
                            <FormControl isInvalid={errors.Gender}>
                                <FormLabel fontSize="sm">Gender</FormLabel>
                                <Select placeholder="Select gender" {...register("Gender")} size="sm">
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Other</option>
                                </Select>
                                {errors.Gender && <Text color="red.500">{errors.Gender.message}</Text>}
                            </FormControl>

                            {/* Profile Picture */}
                            <FormControl isInvalid={errors.profilePic}>
                                <FormLabel fontSize="sm">Profile Picture</FormLabel>
                                <Input type="file" onChange={(e) => setValue("profilePic", e.target.files[0])} size="sm" />
                                {errors.profilePic && <Text color="red.500">{errors.profilePic.message}</Text>}
                            </FormControl>

                            {/* Aadhar */}
                            <FormControl isInvalid={errors.aadhar}>
                                <FormLabel fontSize="sm">Aadhar</FormLabel>
                                <Input type="file" disabled={isDisabled} onChange={(e) => setValue("aadhar", e.target.files[0])} size="sm" />
                                {errors.aadhar && <Text color="red.500">{errors.aadhar.message}</Text>}
                            </FormControl>

                            {/* PAN */}
                            <FormControl isInvalid={errors.PAN}>
                                <FormLabel fontSize="sm">PAN</FormLabel>
                                <Input type="file" disabled={isDisabled} onChange={(e) => setValue("PAN", e.target.files[0])} size="sm" />
                                {errors.PAN && <Text color="red.500">{errors.PAN.message}</Text>}
                            </FormControl>

                            {/* License */}
                            <FormControl isInvalid={errors.license}>
                                <FormLabel fontSize="sm">License</FormLabel>
                                <Input type="file" disabled={isDisabled} onChange={(e) => setValue("license", e.target.files[0])} size="sm" />
                                {errors.license && <Text color="red.500">{errors.license.message}</Text>}
                            </FormControl>

                            {/* Country */}
                            <FormControl isInvalid={errors.CountryCd}>
                                <FormLabel fontSize="sm">Country</FormLabel>
                                <Select
                                    placeholder="Select country"
                                    {...register("CountryCd")}
                                    onChange={handleCountryChange}
                                    size="sm"
                                >
                                    {countries.map((country) => (
                                        <option key={country.id} value={country.id}>
                                            {country.country_name}
                                        </option>
                                    ))}
                                </Select>
                                {errors.CountryCd && <Text color="red.500">{errors.CountryCd.message}</Text>}
                            </FormControl>

                            {/* City */}
                            <FormControl isInvalid={errors.CityCd}>
                                <FormLabel fontSize="sm">City</FormLabel>
                                <Select
                                    placeholder="Select city"
                                    value={cityId}
                                    onChange={handleCityChange}
                                    size="sm"
                                >
                                    {cities.map((ct) => (
                                        <option key={ct.city_id} value={ct.city_id}>
                                            {ct.city_name}
                                        </option>
                                    ))}
                                </Select>
                                {errors.CityCd && <Text color="red.500">{errors.CityCd.message}</Text>}
                            </FormControl>
                        </Grid>

                        <Box textAlign="center" pt={4}>
                            <Button
                                type="submit"
                                size="sm"
                                bg="#62a13b"
                                color="white"
                                _hover={{ bg: "#538d32" }}
                                boxShadow="lg"
                                px={8}
                                py={1}
                                borderRadius="full"
                                fontWeight="bold"
                            >
                                Update Profile
                            </Button>
                        </Box>
                    </form>

                    {/* Links */}
                    <HStack align="start" justify="center" spacing={2} mt={4} wrap="wrap">
                        {userPic && userPic !== "" ? (
                            <Link href={`${backendUrl}/profile/${userPic}`} isExternal color="blue.500">
                                Profile
                            </Link>
                        ) : (
                            <Text color="gray.500">No Profile</Text>
                        )}
                        <Text>|</Text>
                        {aadharPic && aadharPic !== "" ? (
                            <Link href={`${backendUrl}/aadhar/${aadharPic}`} isExternal color="blue.500">Aadhar</Link>
                        ) : (
                            <Text color="gray.500">No Aadhar</Text>
                        )}
                        <Text>|</Text>
                        {PANPic && PANPic !== "" ? (
                            <Link href={`${backendUrl}/pan/${PANPic}`} isExternal color="blue.500">PAN</Link>
                        ) : (
                            <Text color="gray.500">No PAN</Text>
                        )}
                        <Text>|</Text>
                        {licensePic && licensePic !== "" ? (
                            <Link href={`${backendUrl}/license/${licensePic}`} isExternal color="blue.500">License</Link>
                        ) : (
                            <Text color="gray.500">No Licence</Text>
                        )}
                    </HStack>
                    {
                        isApproved == false && isSubmitted == true && (
                            <div className="kyc-container">
                                <div className="kyc-message">
                                    KYC Approval pending from Admin.
                                </div>
                            </div>
                        )
                    }
                </Box>
            </Box>

        </Box>
    )
}

export default Profile
